import { useState, useEffect } from 'react'

import { useRouter } from 'next/router'

// Table
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  PaginationListStandalone
} from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'

import lawFileNames from 'public/law-summary/filenames'

import { columns } from 'src/components/textSummary/ProjectDemoListTableColumns'
import ProjectContentHeader from 'src/components/textSummary/ProjectContentHeader'
import ProjectDemoContent from 'src/components/textSummary/ProjectDemoContent'

/* 판결문 문서 파일 테이블 */
const ProjectFileTable = ({ lawFileList, rowEvents }) => {
  return (
    <div className='border-table'>
      <ToolkitProvider keyField='path' bootstrap4 data={lawFileList} columns={columns} search exportCSV>
        {props => (
          <div>
            {/* Table Area */}
            <div className='block sm:flex justify-between items-center'>
              <h5 className='mb-3 font-bold text-sm lg:mb-2'>
                전체 문서 파일
                <span className='font-bold text-blue-400 ml-2'>{lawFileList.length}</span>
              </h5>
            </div>

            <div>
              <PaginationProvider
                pagination={paginationFactory({
                  custom: true,
                  totalSize: lawFileList.length
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <div className='cursor-pointer'>
                    <BootstrapTable
                      keyField='path'
                      data={lawFileList}
                      columns={columns}
                      rowEvents={rowEvents}
                      noDataIndication=' '
                      {...paginationTableProps}
                      {...props.baseProps}
                      wrapperClasses='table-responsive'
                      classes='mytable-hover2 border-table'
                      rowClasses='mytable-hover-row2'
                    />
                    <div className='flex justify-center items-center w-full'>
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                    <div className='flex justify-end mt-3'>
                      <PaginationTotalStandalone {...paginationProps} />
                    </div>
                  </div>
                )}
              </PaginationProvider>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  )
}

/* 판결문 내용 */
const ProjectContent = ({
  lawFileList,
  fileName,
  setFileName,
  keyText,
  setKeyText,
  downloadText,
  downloadExtractFile
}) => {
  const router = useRouter()

  const getNextFile = currentFileName => {
    const index = lawFileList.map(m => m.fileName).indexOf(currentFileName)

    if (index >= lawFileList.length) {
      return null //마지막
    }
    if (index > 0) {
      return lawFileList[index + 1].fileName
    }
    return null
  }

  const getPrevFile = currentFileName => {
    const index = lawFileList.map(m => m.fileName).indexOf(currentFileName)
    if (index == 0) {
      return null // 처음
    }
    if (index > 0) {
      return lawFileList[index - 1].fileName
    }
    return null
  }

  const OpenLawFile = thisFileName => {
    setFileName(thisFileName)
  }

  if (!fileName && router.pathname !== '/textSummary')
    return (
      <div className='row'>
        <div className='border-table'>선택된 파일이 없습니다.</div>
      </div>
    )

  return (
    <div className='w-full'>
      <div className='whitespace-pre-line break-all pl-3 pb-2'>
        <p className='truncate-2-lines mb-2 text-sm font-bold lg:text-base lg:mb-1'>{fileName}</p>
      </div>
      <div className='aiso_detail_wrap overflow-hidden shadow-md'>
        <ProjectContentHeader
          fileName={fileName || ''}
          getNextFile={getNextFile}
          getPrevFile={getPrevFile}
          OpenLawFile={OpenLawFile}
          setKeyText={setKeyText}
        />
        <ProjectDemoContent
          fileName={fileName || ''}
          keyText={keyText}
          downloadText={downloadText}
          downloadExtractFile={downloadExtractFile}
        />
      </div>
    </div>
  )
}

const ProjectDemo = ({ filename, downloadText, downloadExtractFile }) => {
  const [fileName, setFileName] = useState()
  const [keyText, setKeyText] = useState()

  const router = useRouter()

  useEffect(() => {
    if (lawFileList) {
      setFileName(filename)
      setKeyText([''])
    }
  }, [filename])

  const lawFileList = lawFileNames.files

  const rowEvents = {
    onClick: (e, row) => {
      // 중요 문장 표시 초기화
      setKeyText([''])

      // URL/[filename] 으로 이동으로 바꾸기
      router.push(`/textSummary/${row.fileName}`)
    }
  }

  return (
    <div className='w-full'>
      <div>
        <span className='block mb-2 text-555 text-sm font-bold'>DEMO</span>
        <h1 className='block mb-4 font-bold text-2xl lg:text-3xl'>판결문 요약 데모</h1>
      </div>

      <div className='w-full border-t flex flex-col justify-between lg:flex-row'>
        <div className='w-full pt-12 lg:w-1/3 lg:px-20 lg:pt-12'>
          <ProjectFileTable lawFileList={lawFileList} rowEvents={rowEvents} />
        </div>

        <div className='w-full pt-20 lg:w-2/3 lg:px-32 lg:pt-12'>
          <ProjectContent
            lawFileList={lawFileList}
            fileName={fileName}
            setFileName={setFileName}
            keyText={keyText}
            setKeyText={setKeyText}
            downloadText={downloadText}
            downloadExtractFile={downloadExtractFile}
          />
        </div>
      </div>
    </div>
  )
}

export default ProjectDemo
